import styled from 'styled-components';

const SectionHeading = styled.h2`
  color: ${Styles.color.black};
  font-family: ${Styles.fontFamily.base};
  font-size: 1.25rem;
  font-weight: ${Styles.fontWeight.normal};
  letter-spacing: 'normal';
  margin: 0 0 0.625rem 0;
  text-transform: ${Styles.textTransform.headlines};
`;

export default SectionHeading;
